import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { config } from '@/config';
import { AuthShell } from './AuthShell';

export default function VerifyEmailLanding() {
  const { verificationCode } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const verifyUri = `${config.backendApi}/api/auth/verify/${verificationCode ?? ''}`;
    axios
      .create()
      .get(verifyUri)
      .then(
        () => {
          void navigate('/account/verify-success');
        },
        () => {
          void navigate('/account/verify-fail');
        },
      );
    // Run once on mount only — the verification code can't change without remount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthShell title="Verifying your email">
      <div className="p-6 flex flex-col items-center text-center">
        <Loader2 className="w-6 h-6 text-muted-foreground animate-spin mb-4" />
        <p className="text-sm text-muted-foreground">This should just take a second.</p>
      </div>
    </AuthShell>
  );
}
